module.exports = __webpack_public_path__ + "static/git-rebase-v-merge-4-735c179054be8385937327ef09c9788d.png";